/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo, FC } from 'react';
import { Grid } from '@mui/material';
import dynamic from 'next/dynamic';
import { useSelector } from 'redux/app/store';
import StyledBox from 'views/rebranded-module/GeoViewV2/components/BikeCardsSection/BikeCardsSection.styles';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';
import Dinero from 'views/rebranded-module/common/utils/Dinero';
import PATHS from 'lib/navigation/paths';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { RentalsCard } from 'views/rebranded-module/common/components';

const MainWidgetDialogV2 = dynamic(() => import('views/rebranded-module/common/components/UI/MainWidgetDialogV2').then(
  (file) => file.MainWidgetDialogV2,
));

type BikeStatus = {
  soldout?: boolean;
  tentative?: boolean;
  availableCount?: number;
  valueDeal?: boolean;
};

const BikeCardsSection:FC<any> = (props) => {
  const {
    collapsed,
    rentalData,
    widgetData,
    handleBikeCardClick,
    handleMainWidgetDialogClose,
    handleBikeCardHover,
  } = props;
  const cmsData = useContent();
  const { appState } = useSelector((state) => state.globalData);

  const getBikeStatus = (bike:any) => {
    const status:BikeStatus = {};
    const { pickup_date, dropoff_date, pickup_place } = rentalData?.selected_filters;
    if (pickup_place?.id && dropoff_date && pickup_date) {
      if (bike.availability) {
        if (bike.availability.status == 'soldout') {
          status.soldout = true;
          return status;
        }
        if (bike.availability.status == 'tentative') {
          status.tentative = true;
          return status;
        }
        if (bike.availability.count != null) {
          const { count } = bike.availability;
          if (count > 0) {
            status.availableCount = count;
            return status;
          }
        }
      }
    }
    if (bike.value_deal) {
      status.valueDeal = true;
      return status;
    }
    return {};
  };
  const calculatePriceInCredits = (
    numberOfCredits,
    membershipPromotionPrice,
  ) => {
    if (numberOfCredits && membershipPromotionPrice) {
      if (appState.current_user?.is_member) {
        return numberOfCredits;
      }
      return moneyFormat(Dinero(membershipPromotionPrice));
    }
    return null;
  };
  const preparedBikes = useMemo(
    () => rentalData?.rentals?.map((bike) => {
      const status = getBikeStatus(bike);
      return {
        id: bike.id,
        key: bike.id,
        imageAlt: `Eaglerider ${bike.vehicle_make.name} ${bike.vehicle_model.name}`,
        content: cmsData.RentalsCardComponent,
        image: bike.image_url,
        make: bike.vehicle_make.name,
        name: bike.vehicle_model.name,
        vehicleMake: bike.vehicle_make,
        vehicleModel: bike.vehicle_model,
        specsPath: PATHS.vehicleModel.index(
          bike.location.slug,
          bike.vehicle_make.slug,
          bike.vehicle_model.slug,
        ),
        handleCardClick: () => {
          handleBikeCardClick(bike);
        },
        locationName: `${bike.host?.city_name || bike.host?.name}, ${
          bike.host?.region?.code || bike.host?.country?.name
        }`,
        skipStartAtText: true,
        startPrice: moneyFormat(
          Dinero({
            ...bike.price.rate_per_day,
            currency_code: appState.current_currency.code,
          }),
        ),
        priceInCredits: calculatePriceInCredits(
          bike?.vehicle_model?.number_of_credits,
          bike?.vehicle_model?.membership_promotion_price,
        ),
        noMotorcycleLicense: bike.vehicle_model.requires_no_license,
        oldPrice:
            bike.price.non_discounted_rate_per_day.amount
            === bike.price.rate_per_day.amount
              ? null
              : moneyFormat(
                Dinero({
                  ...bike.price.non_discounted_rate_per_day,
                  currency_code: appState.current_currency.code,
                }),
              ),
        owner: {
          display_name: `${cmsData.GeoPage.eagleRiderLabel} ${
            bike.host.name
          }`,
        },
        ...status,

        location: bike.location?.display_name || null,
      };
    }),
    [rentalData],
  );

  return (
    <StyledBox my={2}>
      <Grid
        container
        rowSpacing={{
          xs: 2,
          md: 4,
          xl: 4,
        }}
        columnSpacing={2}
        data-testid="bikes-container">
        {preparedBikes.map((bike:any, index: number) => (
          <Grid
            item
            xl={collapsed ? 4 : 3}
            lg={collapsed ? 6 : 4}
            md={6}
            xs={12}
            className="BCSGridItem BCSCardV1"
            key={`${bike.id} - ${bike.owner.display_name}`}>
            <RentalsCard
              {...bike}
              dataTestId={index === 0 ? 'geo-bike-card-first' : `geo-bike-card-${bike.id}`}
              onMouseEnter={() => {
                handleBikeCardHover(bike);
              }}
              onMouseLeave={() => {
                handleBikeCardHover(undefined);
              }}
                    />
          </Grid>

        ))}

      </Grid>
      {/* used old one temp.   */}
      {widgetData.open && (
        <MainWidgetDialogV2
          open={widgetData.open}
          handleClose={handleMainWidgetDialogClose}
          reservationData={widgetData.data}
          renderFullWidgetByForce
          fixPosition
          shouldHideTitle
          bikeName={widgetData.bikeData.name}
          image={{
            src: widgetData.bikeData.image,
            alt: widgetData.bikeData.name,
          }}
        />
      )}
    </StyledBox>
  );
};

export { BikeCardsSection };
